import { apiFetch } from './client'

export const alertRulesApi = {
  list: (token: string) =>
    apiFetch<any[]>('/alert-rules', token),

  create: (token: string, data: object) =>
    apiFetch<any>('/alert-rules', token, {
      method: 'POST',
      body: JSON.stringify(data),
    }),

  update: (token: string, id: number, data: object) =>
    apiFetch<any>(`/alert-rules/${id}`, token, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),

  delete: (token: string, id: number) =>
    apiFetch<void>(`/alert-rules/${id}`, token, { method: 'DELETE' }),

  test: (token: string, id: number) =>
    apiFetch<void>(`/alert-rules/${id}/test`, token, { method: 'POST' }),
}
